/* eslint-disable vue/no-parsing-error */
<template>
  <div>
    <div class="container-fluid pt-3">
       <CRow class="pr-2">
    <CCol col="10" xl="10">
      <CCard class="p-0">
        <CCardBody>

 <a-card class="edit-card p-0" style="margin:0;" :body-style="{padding:0}" :loading="saving">
                          <span slot="title">
                            <h6 class="w-100 mb-0 text-muted"><router-link to="/taxonomy">Slovníky</router-link> > Položky slovníka</h6>
                            Slovník</span>
                            <span slot="extra" hidden>
  <a-button size="small" @click="sortByTitle('asc')">A→Z</a-button>
  <a-button size="small" class="ml-2" @click="sortByTitle('desc')">Z→A</a-button>
  <a-button size="small" class="ml-2" v-if="orderDirty" @click="saveOrder">Uložiť poradie</a-button>
</span>




                        <div class="table-responsive">

                          <a-table
      :columns="columns"
      :dataSource="data"
      :rowKey="record => record.id"
      :pagination="pagination"
      :rowSelection="rowSelection"
      :loading="loading"
    >
    <!-- Publikované -->
<template slot="published" slot-scope="published">
  <span v-if="published"><i class="fa fa-check"></i></span>
  <span v-if="!published"><i class="fa fa-times"></i></span>
  <span v-if="null"></span>
</template>
    <template slot="action" slot-scope="inputid">
    <router-link :to="'/edit-taxonomy-item/' + inputid + '/' + id"><a-button class="mr-2">Upraviť</a-button></router-link>
        <a-popconfirm placement="topRight"
                      @confirm="confirm(inputid)"
                      @cancel="cancel"
                      okText="Áno"
                      cancelText="Nie">
            <template slot="title">
                <h5 color="danger" >Prajete si tento obsah vymazať?</h5>
                Položka bude trvalo odstránená z vašej stránky.
            </template>
            <a-button type="secondary"  icon="fas fa-trash"    textColor="default" title="Zmazať">Zmazať</a-button>
        </a-popconfirm>
    </template>
    </a-table>
    <div v-if="rowSelection.selectedRowKeys.length > 0" class="action-panel">
      <a-select
        style="width:150px;"
        v-model="action"
        placeholder="Vyberte si akciu"
        :options="actions"
      />
      <a-select  v-if="action == 'multiedit'" mode="multiple" style="width:150px;"  class="mr-3" size="small" placeholder="Vyberte si polia" v-model="actionFields"  :options="allfields"></a-select>

      <template v-if="action !== 'multiedit'">
        <a-popconfirm
          placement="topRight"
          @confirm="doAction"
          okText="Áno"
          cancelText="Nie"
        >
          <a-button type="warning">Vykonať</a-button>
        </a-popconfirm>
      </template>
      <template v-else>
        <a-button type="secondary" @click="multiedit">Do úprav</a-button>
      </template>
    </div>
  </div>


                      </a-card>
                      </CCardBody>
                            </CCard>
                            </CCol>


<CCol col="2" xl="2" class=" option-card pl-0">
<CCard class="pl-0 pt-0">
  <CCardBody>
    <a-card class="edit-card" style="margin:0; padding:15px;" :loading="saving">
     <div class="option-buttons">
                                   <router-link :to="'/add-taxonomy-item/' + id "><a-button type="primary" >Nová položka slovníka</a-button></router-link>
            <router-link :to="'/taxonomy/' + id "><a-button type="secondary" class="mr-2">Nastavenia slovníka</a-button></router-link>
            <router-link :to="'/tree-taxonomy-items/' + id"><a-button type="secondary" class="mr-2">Preusporiadať</a-button></router-link>
                            </div>

      </a-card>

  </CCardBody>
</CCard>
  </CCol>


                            </CRow>

                    </div>
</div>
</template>
<script>
    import {dataService} from "../../_services";
    import {Popconfirm} from "ant-design-vue"

    import draggable from "vuedraggable";

    export default {
        name: "taxonomyitems",
        props: ['id'],
        components: {
            "a-popconfirm": Popconfirm, draggable
        },
        data() {
            return {
              data: [],
              saving: false,
              orderDirty: false,
              allfields:[],
              actionFields:[],
      action: undefined,
      pagination: {
                    hideOnSinglePage: true,
                    pageSize: 100, // default number of pages per page
                    showSizeChanger: true, // display can change the number of pages per page
                    pageSizeOptions: ['10', '20', '30', '40', '100'], // number of pages per option
                    showTotal: total => `Položiek: ${total}`, // show total
                    showSizeChange: (current, pageSize) => {  this.pageSize = pageSize; }, // update display when changing the number of pages per page
                },
      actions: [
        { value: "delete", label: "Zmazať" },
        { value: "export", label: "Exportovať" },
        { value: "multiedit", label: "Hromadná úprava" }
      ],
      selectedRowKeys: [],
      columns: [
  {
    title: 'Položka',
    dataIndex: 'title',
    key: 'title',
    sorter: (a,b) => (a.title || '').localeCompare(b.title || '', 'sk', {sensitivity:'base'}),
    sortDirections: ['ascend','descend']
  },
  {
    title: 'Publikované',
    dataIndex: 'published',
    key: 'published',
    width: 140,
    scopedSlots: { customRender: 'published' }
  },
  {
    title: 'URL',
    dataIndex: 'url',
    key: 'url',
    scopedSlots: { customRender: 'url' }
  },
  {
    dataIndex: 'id',
    key: 'id',
    align: 'right',
    scopedSlots: { customRender: 'action' },
  }
],
                dragging: false,
                colorsto: JSON.parse(localStorage.colors),
                loading: false,
            };
        },
        computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: (selectedRowKeys) => {
          this.selectedRowKeys = selectedRowKeys;
        }
      };
    }
  },
        mounted() {
            this.fetch();
        },
        methods: {
          doAction() {
      // Implementujte logiku pre vykonanie akcie na vybraných položkách.
      // Napríklad:
      dataService.axiosPost('action/taxonomy/' + this.action, { items: this.selectedRowKeys })
        .then(() => {
          this.$message.success('Akcia vykonaná');
          // Obnovte dáta alebo resetujte výber:
          this.selectedRowKeys = [];
          this.fetch();
        });
    },
    sortByTitle(dir = 'asc') {
  const mul = dir === 'asc' ? 1 : -1;
  this.data.sort((a, b) => mul * ( (a.title || '').localeCompare((b.title || ''), 'sk', {sensitivity:'base'}) ));
  this.orderDirty = true; // označíme, že poradie sa zmenilo
},
saveOrder() {
  this.updateOrder();
  this.orderDirty = false;
},
    multiedit()
            {
                this.$router.push({ name: 'multiedittaxonomy', query: { id:this.id, nids: this.rowSelection.selectedRowKeys.join(','), acfields: this.actionFields.join(',') } });
            },
            confirm(e) {
                dataService.axiosDelete(this.$options.name, e).then(results => {
                    if (results) {
                        this.data.splice(this.data.findIndex(x => parseInt(x.id) === parseInt(e)), 1);
                    }
                });
            },
            cancel() {
            },
            updateOrder()
            {
                dataService.axiosPost("reorder/taxonomy", this.data).then(results => {
                    if(results.data)
                    {
                        this.$message.success('Položky boli zoradené');
                    }

                })
            },
            fetch() {
                this.loading = true;
                dataService.axiosFetch(this.$options.name,this.id).then(results => {
                    this.data = results;
                    this.loading = false;
                });




                dataService.axiosFetch("taxonomy/" + this.id).then(results => {


                            if(results.fields)
                          {

                            results.fields.forEach(obj => {

                            if(obj.type == "1" || obj.type == "5" || obj.type == "6" || obj.type == "7" || obj.type == "4" || obj.type == "12")
                            {
                                this.allfields.push({"value":obj.slug,"label":obj.title});
                            }
                            })
                          }

                      });






            }

        },
    };
</script>

<style>
    ul.ant-pagination {
        margin-top: 0;
        margin-bottom: 1em;
    }

    .handle i
    {
        color: #888888;
    }
    .ant-table-pagination.ant-pagination {
        margin-bottom: 40px;
        margin-right: 20px;
    }

    .ant-pagination5-item {
        border: 0;
    }

    .ant-table {
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);
        margin-bottom: 20px;
    }

    .ant-pagination5-item a, .ant-pagination5-prev a, .ant-pagination5-next a, .ant-pagination5-jump-prev a, .ant-pagination5-jump-next a {
        -webkit-box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
        box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
        border: 0;
    }
.edit-card .ant-card-body
     {padding:0;}
    .ant-pagination5-item a, .ant-pagination5-prev a, .ant-pagination5-next a {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        padding: 0;
        margin: 0 3px;
        border-radius: 50% !important;
        width: 36px;
        height: 36px;
        font-size: 0.875rem;
    }


    .ant-pagination5-item.ant-pagination5-item-active a {
        z-index: 1;
        color: #fff;
        background-color: #5e72e4;
        border-color: #5e72e4;
    }

    .ant-pagination5-item-link.ant-pagination5-disabled a {
        color: #8898aa;
        pointer-events: none;
        cursor: auto;
        background-color: #fff;
        border-color: #dee2e6;
    }

</style>
